export default __webpack_public_path__ + "static/media/ea-icon-active.2d7138cd.svg";